import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/current_projects.css";
import { apiUrl } from "../config/api";

const CurrentProjects = () => {
  const [projects, setProjects] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const getImageUrl = (img) => {
      if (!img) return null;
      if (/^https?:\/\//i.test(img)) return img;
      return apiUrl(img);
    };

    const normalize = (project, index) => {
      const id = project.id || 1000 + index;

      return {
        id,
        section: "projects",
        heading: project.heading || project.title || "Untitled project",
        url_link: `/mediaPublications/project${id}`,
        content: project.content || project.description || "",
        image: getImageUrl(project.image || project.thumbnail || project.logo),
        order: project.order ?? index,
      };
    };

    const fetchProjects = async () => {
      try {
        const response = await fetch(apiUrl("/api/home_sections/projects"));
        if (!response.ok) {
          throw new Error(`Failed to fetch projects: ${response.status}`);
        }

        const json = await response.json();
        const projectRows = Array.isArray(json)
          ? json
          : Array.isArray(json.projects)
            ? json.projects
            : [];

        const normalizedProjects = projectRows
          .map((project, index) => normalize(project, index))
          .sort((a, b) => a.order - b.order);

        if (mounted) {
          setProjects(normalizedProjects);
        }
      } catch (error) {
        if (mounted) {
          setProjects([]);
        }
      }
    };

    fetchProjects();

    return () => {
      mounted = false;
    };
  }, []);

  const prevSlide = () => {
    setCurrentIndex(
      projects.length === 0 ? 0 : (currentIndex - 1 + projects.length) % projects.length
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      projects.length === 0 ? 0 : (currentIndex + 1) % projects.length
    );
  };

  const getTranslateX = () => {
    if (!slideRef.current) return 0;
    const slideWidth = slideRef.current.offsetWidth;
    return currentIndex * (slideWidth + 20);
  };

  const handleProjectClick = (project) => {
    navigate(project.url_link);
  };

  return (
    <div className="current-projects">
      <h2>
        <span className="line"></span>
        CURRENT PROJECTS
        <span className="line"></span>
      </h2>

      <div className="slider-container">
        <button className="arrow left-arrow" onClick={prevSlide}>
          &#10094;
        </button>

        <div className="slider-wrapper">
          <div
            className="slider"
            style={{ transform: `translateX(-${getTranslateX()}px)` }}
          >
            {projects.length > 0 ? (
              projects.map((slide) => (
                <div
                  key={slide.id}
                  className="project-slide"
                  ref={slideRef}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="project-content"
                    onClick={() => handleProjectClick(slide)}
                  >
                    <h3>{slide.heading}</h3>
                    <p>{slide.content}</p>
                    <button
                      className="read-more-btn"
                      onClick={() => handleProjectClick(slide)}
                    >
                      Read more →
                    </button>
                  </div>
                  <div className="project-image">
                    {slide.image && (
                      <img
                        className="carousel-image1"
                        src={slide.image}
                        alt={slide.heading}
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="project-slide">
                <p>No projects available</p>
              </div>
            )}
          </div>
        </div>

        <button className="arrow right-arrow" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default CurrentProjects;
